export const FETCH_MASTER_BARCODES_RESOLVED = "FETCH_BARCODES_RESOLVED";
export const DELETE_MASTER_BARCODE_RESOLVED = "DELETE_MASTER_BARCODE_RESOLVED";
